import { FC, useMemo } from 'react';
import Select from '../form/select';
import { sortBy } from 'lodash';
import useUserSettings from '@/hooks/use-user-settings.hook';

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  label?: string;
}

const PrivateModelSelect: FC<Props> = ({ value, onChange, disabled = false, label: propLabel }) => {
  const { privateModelSettings, isLoading, defaultAgent } = useUserSettings();

  const privateModelOpts = useMemo(() => {
    const opts = sortBy(privateModelSettings.availablePrivateModels || [], 'name').map(
      ({ id, name }) => ({
        value: id,
        label: name,
      })
    );
    return opts;
  }, [privateModelSettings]);

  const label = useMemo(() => {
    if (propLabel) {
      return propLabel;
    }

    if (!defaultAgent) {
      return 'Default Assistant Model';
    }

    return `${defaultAgent.badgeTitle} Model`;
  }, [defaultAgent, propLabel]);

  return (
    <Select
      name="privateModelId"
      label={label}
      value={value || privateModelSettings.defaultPrivateModelId}
      options={privateModelOpts}
      onChange={onChange}
      fullWidth
      size="small"
      disabled={disabled}
      loading={isLoading}
    />
  );
};

export default PrivateModelSelect;
